import { createEntity } from 'lib/resource';
import store from 'app/store';
import Schema from './entity-schema';

export default createEntity(Schema, {
  getState() {
    return store.get().getState();
  },
});
